import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Customers } from './Customers'
import { Featured } from './Featured'
import { ReferenceCustomersProps } from './types'

export const ReferenceCustomers: FC<ReferenceCustomersProps> = ({
  seo,
  header,
  footer,
  content: { breadcrumb, title, subtitle, description, featured_img, customers }
}) => (
  <Page seo={seo} header={header} footer={footer}>
    <Featured
      breadcrumb={breadcrumb}
      title={title}
      subtitle={subtitle}
      description={description}
      featured_img={featured_img}
    />
    <Customers customers={customers} />
  </Page>
)
